import { useTranslation } from 'next-i18next';
import { useOpenWindow } from '@/hooks';
import { ChevronRightIcon, XIcon } from '@/icons';
import { Button, DialogTitle, IconButton, ResponsiveDialog } from '@/ui_v3';
type RestrictedPlanDialogProps = {
  onClose?: VoidFunction;
};

/** 단체 플랜 사용자의 구매 시도 시 안내하는 Figma 14773:41368 상태. */
export const RestrictedPlanDialog = ({
  onClose
}: RestrictedPlanDialogProps) => {
  const {
    t
  } = useTranslation(['common']);
  const openWindow = useOpenWindow();
  return <ResponsiveDialog size="sm" onClose={onClose} className="gap-none" data-sentry-element="ResponsiveDialog" data-sentry-component="RestrictedPlanDialog" data-sentry-source-file="RestrictedPlanDialog.tsx">
      <header className="flex w-full items-center gap-none px-md pb-xs pt-md">
        <DialogTitle className="min-w-0 flex-1 text-heading-md-bold" data-sentry-element="DialogTitle" data-sentry-source-file="RestrictedPlanDialog.tsx">
          {t('common:upselling.restricted.title')}
        </DialogTitle>
        <IconButton variant="transparent" intent="neutral" size="sm" aria-label={t('common:global.close.button')} onClick={onClose} data-sentry-element="IconButton" data-sentry-source-file="RestrictedPlanDialog.tsx">
          <XIcon size="md" data-sentry-element="XIcon" data-sentry-source-file="RestrictedPlanDialog.tsx" />
        </IconButton>
      </header>

      <div className="w-full px-md text-body-md-regular text-default">
        <p>{t('common:upselling.restricted.description')}</p>
      </div>

      <footer className="flex w-full flex-col gap-xs px-md py-md">
        <Button size="lg" intent="strong" className="w-full" rightSlot={<ChevronRightIcon size="md" />} onClick={() => openWindow('/profile/plan')} data-sentry-element="Button" data-sentry-source-file="RestrictedPlanDialog.tsx">
          {t('common:upselling.restricted.viewPlan')}
        </Button>
        <Button size="lg" intent="neutral" className="w-full" onClick={() => window.open(t('common:upselling.restricted.planUsageGuideUrl'), '_blank', 'noopener,noreferrer')} data-sentry-element="Button" data-sentry-source-file="RestrictedPlanDialog.tsx">
          {t('common:upselling.restricted.planUsageGuide')}
        </Button>
      </footer>
    </ResponsiveDialog>;
};